export default __webpack_public_path__ + "static/media/H1007.4.56b2ef79.mp3";